import { useMemo } from "react";
import useDeliveryServiceProviders from "./useDeliveryServiceProviders";
/**
 * Wrapper over useDeliveryServiceProviders fn. Filters and provides the details of the required lpId.
 * @param lpId
 * @returns DeliveryServiceProviderDetails
 */ function useDeliveryServiceProviderDetails(dspId) {
    var deliveryServiceProviders = useDeliveryServiceProviders();
    var dspDetails = useMemo(function() {
        return deliveryServiceProviders.find(function(param) {
            var logisticsPartyId = param.logisticsPartyId;
            return logisticsPartyId === dspId;
        });
    }, [
        deliveryServiceProviders,
        dspId
    ]);
    return dspDetails || null;
}
export default useDeliveryServiceProviderDetails;

//# sourceMappingURL=useDeliveryServiceProviderDetails.js.map